"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const seminarTrainersGrid = Array.from(document.querySelectorAll('.tx-ttaddress-contact-teaser-w-image-square'));
if (seminarTrainersGrid) {
    seminarTrainersGrid.forEach((trainer) => {
        if (trainer.previousElementSibling.tagName === "SPAN") {
            trainer.previousElementSibling.classList.add('pseudo-headline-block');
        }
    });
}
exports.default = {};
